"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapAdvancedSearchOpToStringColumnFilter = mapAdvancedSearchOpToStringColumnFilter;
function mapAdvancedSearchOpToStringColumnFilter(field, operator, value) {
    switch (operator) {
        case 'begins-with':
            return { column: field, op: 'begins-with', value: value };
        case 'not-begins-with':
            return { op: 'not', filter: [{ column: field, op: 'begins-with', value: value }] };
        case 'ends-with':
            return { column: field, op: 'ends-with', value: value };
        case 'not-ends-with':
            return { op: 'not', filter: [{ column: field, op: 'ends-with', value: value }] };
        case 'contains':
            return { column: field, op: 'contains', value: value };
        case 'not-contains':
            return { op: 'not', filter: [{ column: field, op: 'contains', value: value }] };
        case 'equals':
            return { column: field, op: '=', value: value };
        case 'not-equals':
            return { column: field, op: '!=', value: value };
    }
    throw Error('Not supported filter operator');
}
